import { transferringListStateName } from '../../../../components/tickets/ticketOverview/ticketOverview.state';
import { authorizationStateName } from '../../../../components/ticket/states/authorization/authorization.state';
import { uploadStateName } from '../../../../components/ticket/states/upload/upload.state';
import { selectStateName } from '../../../../components/ticket/states/select/select.state';
import { transferringClosedStateName } from '../../../../components/ticket/states/closed/closed.state';
import { transferringCompletedStateName } from '../../../../components/ticket/states/completed/completed.state';
import { uploadWarrantStateName } from '../../../../components/tickets/create/transferring/uploadWarrant/uploadWarrant.state';
import { TicketType } from '../../../../components/ticket/ticket.constants';
import { UserPermissions } from '../../../user/user.roles';

export const TransferringTab = {
  id: TicketType.Transferring,
  ref: transferringListStateName,
  text: 'navbar.link.transferring.title',
  activeStates: [
    authorizationStateName,
    uploadStateName,
    selectStateName,
    transferringClosedStateName,
    transferringCompletedStateName,
  ],
  requiresAuth: true,
  permissions: [
    UserPermissions[TicketType.Transferring].Read,
    UserPermissions[TicketType.Transferring].Create,
    UserPermissions[TicketType.Transferring].Complete,
  ],
  dropdown: {
    tickets: {
      ref: transferringListStateName,
      text: 'navbar.link.transferring.tickets.title',
      icon: 'fa fa-fw m-right-xs-5 fa-tasks',
      permissions: [
        UserPermissions[TicketType.Transferring].Read,
        UserPermissions[TicketType.Transferring].Complete,
      ],
    },
    request: {
      ref: uploadWarrantStateName,
      text: 'navbar.link.transferring.request.title',
      icon: 'fa fa-fw m-right-xs-5 fa-upload',
      permissions: [UserPermissions[TicketType.Transferring].Create],
    },
  },
};
